import { queryIds } from '@/shared/utils/constants';

export const SELECTOR_CASES_QUERY_KEY = [queryIds.cases.GET_SELECTOR_CASES];

/** The selector list returns every case of the team; keep it cached and refresh it through invalidation. */
export const SELECTOR_CASES_STALE_TIME = 5 * 60 * 1000;